import { createApp } from 'vue'
import appDrawer from './app.vue';
import focusTrap from '../../utils/focus-trap';
import commonStore from '../global/common-store';

export default () => {
  createApp(appDrawer).directive('focus-trap', focusTrap).use(commonStore).mount("vue-global-drawer")
}